var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 5.75,
    fill: "#EFFCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 5.75,
    stroke: "#34656D",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7648 12.7697V20.8337C23.7461 21.3611 23.6232 21.8797 23.4032 22.3594C23.1832 22.8392 22.8704 23.2707 22.4829 23.629C22.095 23.989 21.6401 24.269 21.144 24.4531C20.6479 24.6372 20.1204 24.7217 19.5916 24.7019H12.4481C11.916 24.7262 11.3845 24.6453 10.8838 24.4638C10.3831 24.2822 9.92321 24.0037 9.53041 23.644C9.13913 23.2847 8.82316 22.8513 8.60084 22.3688C8.37851 21.8864 8.25428 21.3646 8.23535 20.8337V11.164C8.25404 10.6366 8.37693 10.118 8.59693 9.63827C8.81694 9.15852 9.12971 8.72706 9.51723 8.36874C9.90507 8.00876 10.36 7.72872 10.8561 7.54462C11.3522 7.36052 11.8797 7.27597 12.4085 7.2958H17.7864C18.6074 7.2929 19.3998 7.59666 20.0085 8.14756L22.7944 10.7094C23.0917 10.9655 23.3317 11.2813 23.4989 11.6363C23.6661 11.9912 23.7567 12.3774 23.7648 12.7697Z",
    fill: "#34656D",
    stroke: "#34656D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5869V20.9624",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9228 17.2705L16.4145 14.7622C16.3603 14.7073 16.2956 14.6637 16.2244 14.634C16.1531 14.6042 16.0767 14.5889 15.9995 14.5889C15.9223 14.5889 15.8458 14.6042 15.7746 14.634C15.7033 14.6637 15.6387 14.7073 15.5844 14.7622L13.0762 17.2714",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0576 7.29688V10.6813C18.0576 11.1397 18.2402 11.5802 18.5659 11.9049C18.8923 12.2299 19.3343 12.4123 19.795 12.4122H23.6774",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.3938f13580eeca9566de5931b2a076e7.svg";
export { ForwardRef as ReactComponent };